/** Espelha `backend/src/historico-paciente/historico.tipos.ts`. */

export type SistemaHistorico = 'esus' | 'sisreg';

export type TipoRegistroHistorico = 'solicitacao' | 'marcacao';

export interface PacienteHistorico {
  nome: string | null;
  cpf: string | null;
  cns: string | null;
  dataNascimento: string | null;
  nomeMae: string | null;
  municipioResidencia: string | null;
}

export interface ItemHistorico {
  tipo: TipoRegistroHistorico;
  codigo: string | null;
  procedimento: string | null;
  codigoProcedimento: string | null;
  cid: string | null;
  classificacaoRisco: string | null;
  situacao: string | null;
  dataSolicitacao: string | null;
  dataMarcacao: string | null;
  horaMarcacao: string | null;
  unidadeSolicitante: string | null;
  unidadeExecutante: string | null;
  municipioExecutante: string | null;
  profissionalSolicitante: string | null;
  profissionalExecutante: string | null;
}

export interface HistoricoSistema {
  sistema: SistemaHistorico;
  configurado: boolean;
  paciente: PacienteHistorico | null;
  itens: ItemHistorico[];
  limiteAtingido: boolean;
}

/** O que identifica o paciente na consulta: o documento, ou a solicitação. */
export type ChaveHistorico = { cpf: string } | { cns: string } | { solicitacaoId: string };

export const ROTULOS_SISTEMA: Record<SistemaHistorico, string> = {
  esus: 'eSUS Regulação',
  sisreg: 'SISREG 3',
};

export interface ConexaoSisreg {
  id: number;
  ativo: boolean;
  baseUrl: string | null;
  indiceMarcacao: string | null;
  indiceSolicitacao: string | null;
  usuario: string | null;
  timeoutMs: number;
  temSenha: boolean;
  ultimoTesteEm: string | null;
  ultimoTesteOk: boolean | null;
  ultimoTesteMsg: string | null;
  atualizadoEm: string;
}
